<template>
  <div
    v-if="controllers.length"
  >
    <div
      v-for="(node, index) in controllers"
      :key="index"
    >
      <ContainerProbeList
        :id="node.id"
        :node="node"
        :parentNode="node"
        @sendData="updateData"
        @updateParentClick="updateParentClick"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from 'vuex';

export default {
    components: {
    },
    props: {
        analysisConfigurationId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            data: {
                probeId: '',
            },
            controllers: [],
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
    },
    async created() {
        await this.getComponentConfiguration();
        await this.getControllers();
    },
    methods: {
        updateData(data) {
            if (data) {
                this.$emit('sendData', data);
            }
        },
        async getComponentConfiguration() {
            const { data } = await this.$rq.getComponentConfiguration(this.analysisConfigurationId);
            this.data = data;
        },
        async getControllers() {
            const { data } = await this.$rq.getControllers(this.site.id);
            this.controllers = data.controllers;
        },
        updateParentClick(parentId) {
            this.controllers = this.controllers.map(controller => {
                controller.clicked = controller.id === parentId;
                return controller;
            });
        },
    },
};
</script>
